import { Link } from '@material-ui/core'
import LaunchIcon from '@material-ui/icons/LaunchOutlined'
import { useTranslate } from 'ra-core'
import { FC, ReactNode } from 'react'

type Props = {
  href: string
  title?: ReactNode | false
}

export const HelpLink: FC<Props> = ({ title, href }) => {
  const translate = useTranslate()
  if (!title && title !== false) title = translate('Help Center')
  return (
    <Link href={href} referrerPolicy="no-referrer" target="_blank" aria-label={'Help center article'}>
      <LaunchIcon style={{ width: 15, height: 15, verticalAlign: 'sub' }} />
      {title && <>&nbsp;{title}</>}
    </Link>
  )
}
